export default __webpack_public_path__ + "static/media/Inconsolata.d436e6cb.ttf";